module.exports = __webpack_public_path__ + "static/media/helpcard_rental.e96e2168.svg";